import { render, staticRenderFns } from "./FuWuNeiRongView.vue?vue&type=template&id=0b19cdf2&scoped=true"
import script from "./FuWuNeiRongView.vue?vue&type=script&lang=js"
export * from "./FuWuNeiRongView.vue?vue&type=script&lang=js"
import style0 from "./FuWuNeiRongView.vue?vue&type=style&index=0&id=0b19cdf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19cdf2",
  null
  
)

export default component.exports